// extracted by mini-css-extract-plugin
export var banner = "HeadingBanner-module--banner--DUCXU";
export var content = "HeadingBanner-module--content--VtnNQ";
export var description = "HeadingBanner-module--description--SpS3a";
export var heading = "HeadingBanner-module--heading--Zzr+h";